import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css'
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdCheck, MdEdit } from 'react-icons/md'
import DataTable from '../../components/ui/DataTable'
import Button from '../../components/ui/Button'
import notify from '../../utils/IANotification'
import { tidy_date } from '../../utils/helper'

export default function EmailNewsletterPage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user")
  useFetchUserData()

  const [newsletters, setNewsletters] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchNewsletters()
  }, [])

  const fetchNewsletters = async () => {
    setLoading(true)
    try {
      const res = await fetch(config.endpoint + "/campaigns/email-newsletter", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      })
      const data = await res.json()
      if (data.status === 200) {
        setNewsletters(data.data || [])
      } else {
        notify({ message: "Failed to load newsletters", type: "error" })
      }
    } catch (err) {
      notify({ message: "Failed to load newsletters", type: "error" })
    }
    setLoading(false)
  }

  const STATUS_BADGE = {
    draft: "bg-amber-100 text-amber-800",
    scheduled: "bg-blue-100 text-blue-800",
    sent: "bg-emerald-100 text-emerald-800",
  }

  const table_columns = [
    { header: "Title", accessor: "title" },
    { header: "Subject", accessor: "subject" },
    {
      header: "Status",
      accessor: "status",
      modifier: (val) => (
        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold capitalize ${STATUS_BADGE[val] || "bg-gray-100 text-gray-700"}`}>
          {val}
        </span>
      )
    },
    {
      header: "Scheduled",
      accessor: "scheduled_datetime",
      modifier: (val) => val ? tidy_date(val) : "—"
    },
    {
      header: "Sent At",
      accessor: "sent_at",
      modifier: (val) => val ? <><MdCheck className="inline text-emerald-600" /> {tidy_date(val)}</> : "—"
    },
  ]

  return (
    <AdminLayout
      navSelected={"Email Newsletter"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Email Newsletter</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => navigate("/admin/campaigns/email-newsletter/details?newsletter_id=new")}
          >
            <MdAdd size={16} />
            New Newsletter
          </button>
        </>
      }
    >
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={newsletters}
            enableActions
            actions={(row) => (
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  icon={MdEdit}
                  onClick={() => navigate(`/admin/campaigns/email-newsletter/details?newsletter_id=${row.id}`)}
                >
                  Edit
                </Button>
              </div>
            )}
          />
        </div>
      )}
    </AdminLayout>
  )
}
